export const L10N = {
  ACTION_BOOK_NOW: { id: 'core.action.book_now' },
  ACTION_FINAL_DETAILS: { id: 'core.action.final_details' },
  ACTION_PAY_NOW: { id: 'core.action.pay_now' },
};
